export default __webpack_public_path__ + "static/media/logo_cliente.ad1df197.png";